import { useEffect, useState } from "react";

function Plan(props) {
  const [contractPlanId, setContractPlanId] = useState(undefined);

  useEffect(() => {
    const student = props.item;
    if (student.contractPlanId) {
      setContractPlanId(student.contractPlanId);
    }
    // eslint-disable-next-line
  }, []);

  const handlerPlan = (e) => {
    const { value } = e.target;
    setContractPlanId(value);
    props.onChange(e);
  };

  const { t, plans } = props;
  return (
    <div>
      <div>
        <label>{t("PLANS")}</label>
        <span className="invalid">{t("REQUIRED")}</span>
      </div>
      <select
        value={contractPlanId}
        onChange={(e) => handlerPlan(e)}
        className="input-lingo mediumSelect"
        name="contractPlanId"
      >
        <option value="">{t("SELECT")}</option>
        {plans.map((i) => {
          return (
            <option key={i.contractPlanId * 9} value={i.contractPlanId}>
              {i.nameEnglish}
            </option>
          );
        })}
      </select>
    </div>
  );
}

export default Plan;
